var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "field is-horizontal" }, [
          _c("div", { staticClass: "field-body" }, [
            _c("div", { staticClass: "field-body" }, [
              _c("div", { staticClass: "field has-addons" }, [
                _c(
                  "div",
                  { staticClass: "control has-icons-left has-icons-right" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filter.query,
                          expression: "filter.query",
                        },
                      ],
                      staticClass: "input",
                      attrs: {
                        type: "text",
                        placeholder: "Start typing to filter",
                      },
                      domProps: { value: _vm.filter.query },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.filter, "query", $event.target.value)
                          },
                          _vm.search,
                        ],
                      },
                    }),
                    _vm._m(0),
                  ]
                ),
                _c("div", { staticClass: "control" }, [
                  _c(
                    "a",
                    {
                      staticClass: "button is-primary is-outlined",
                      on: {
                        click: function ($event) {
                          return _vm.reset()
                        },
                      },
                    },
                    [_vm._m(1)]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c(
        "bulma-table",
        {
          staticClass: "table is-bordered is-striped is-narrow is-fullwidth",
          attrs: {
            columns: _vm.columns,
            "page-index": _vm.filter.pageIndex,
            "page-size": _vm.filter.pageSize,
            "total-rows": _vm.totalRows,
            "is-loading": _vm.isTableLoading,
            "sort-column": _vm.filter.sortColumn,
            "sort-order": _vm.filter.sortOrder,
          },
          on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
        },
        [
          _vm._l(_vm.quickItems, function (item, index) {
            return _c(
              "tr",
              {
                key: item.itemQuickId,
                class: { "is-selected": _vm.selectedRow === index },
                on: {
                  dblclick: function ($event) {
                    return _vm.addNewItem(item, index)
                  },
                  click: function ($event) {
                    return _vm.highlightSelected(index, $event)
                  },
                },
              },
              [
                _c("td", [_vm._v(_vm._s(_vm.$filters.pad(item.itemNo, 3)))]),
                _c("td", [_vm._v(_vm._s(item.description))]),
                _c("td", { staticClass: "has-text-right" }, [
                  _vm._v(_vm._s(item.quantity)),
                ]),
                _c("td", [
                  _c("div", { staticClass: "has-text-right" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatNumber(
                          item.price,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]),
                ]),
                _c("td", [
                  _c("div", { staticClass: "has-text-centered" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "button is-primary is-small is-inverted tooltip is-tooltip-topright",
                        attrs: {
                          "data-tooltip":
                            "Click or double-click row to add item",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.addNewItem(item, index)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "icon is-medium" }, [
                          _c("i", { staticClass: "mdi mdi-plus mdi-24px" }),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]
            )
          }),
          _c("template", { slot: "empty" }, [
            _c(
              "div",
              { staticClass: "content has-text-grey has-text-centered" },
              [
                _c("span", { attrs: { icon: "icon is-large" } }, [
                  _c("i", { staticClass: "mdi mdi-36px mdi-emoticon-sad" }),
                ]),
                _c("p", [_vm._v("Nothing")]),
              ]
            ),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-left" }, [
      _c("i", { staticClass: "mdi mdi-magnify mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close mdi-18px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }